import React from "react"
import Icon from "@ng-mw/reol/components/Icon"
import iconClock from "@ng-mw/reol/icons/clock"

import "./style/recipe-time.scss"

interface RecipeTimeProps {
    className?: string
    iconSize?: {
        width: string
        height: string
    }
    time: string
}

const RecipeTime = ({
    className = "",
    iconSize = {
        width: "17px",
        height: "17px",
    },
    time,
}: RecipeTimeProps) => {
    const style = {
        "--recipe-time-icon-width": iconSize.width,
        "--recipe-time-icon-height": iconSize.height,
    } as React.CSSProperties

    return (
        <div
            className={`ws-recipe__time ${className}`.trim()}
            style={style}
        >
            <Icon
                icon={iconClock}
                size={iconSize}
            />
            {time}
        </div>
    )
}

export default RecipeTime
